import { RepositoryOverlay } from '#app/routes/mocra+/_form+/components/repositories/overlay.tsx'
import { type RepositoryDraft } from '#app/routes/mocra+/_form+/components/repositories/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: RepositoryDraft) => void
	readonly initialValue: RepositoryDraft
	readonly onClosed?: () => void
}

export function RepositoryEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
}: Props) {
	return (
		<RepositoryOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
		/>
	)
}
